// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2FjDo","signatureBlock":"Footer_signatureBlock__2kL9K","signature":"Footer_signature__14KuT"};